<template>
  <div v-if="message.value" class="toaster-container" :style="{opacity: currentOpacity, backgroundColor: backgroundColor}">
    <div class="toaster-message">
      <slot name="message">
        <span v-html="message.value"></span>
      </slot>
    </div>
    <div class="toaster-icon-container">
      <img class="toaster-close-icon" alt="cross icon" src="@/assets/images/close-white-icon.svg" @click="fadeOut" />
    </div>
  </div>
</template>
<script setup>
import { ref, computed, watch, onMounted } from 'vue';

// Define component name
defineOptions({
  name: 'Toaster'
});

// Props
const props = defineProps({
  message: {
    type: Object,
    required: true,
  },
});

// Emits
const emit = defineEmits(['close']);

// Reactive data
const currentOpacity = ref(0);
const removeImgElem = ref(false);
const duration = ref(0);

// Computed properties
const backgroundColor = computed(() => {
  if (props.message.type === 'success') {
    return '#285298';
  }
  return '#dc4431';
});

// Methods
const show = () => {
  fadeIn();
};

const fadeIn = () => {
  const fadeInInterval = setInterval(() => {
    if (currentOpacity.value < 1) {
      currentOpacity.value += 0.01;
    } else {
      clearInterval(fadeInInterval);
      if (duration.value) {
        setTimeout(fadeOut, duration.value);
      }
    }
  }, 10);
};

const fadeOut = () => {
  const fadeOutInterval = setInterval(() => {
    if (currentOpacity.value > 0) {
      currentOpacity.value -= 0.01;
    } else {
      clearInterval(fadeOutInterval);
      emit('close');
    }
  }, 10);
};

// Watchers
watch(duration, (newVal) => {
  if (newVal) {
    setTimeout(fadeOut, newVal);
  }
});

// Lifecycle hooks
onMounted(() => {
  duration.value = props.message.timeout;
  show();
});
</script>
<style scoped lang="stylus">
.toaster-container {
  z-index : 1000;
  position: absolute;
  display:flex;
  flex-direction: row;
  top: 20px;
  left: 0;
  right: 0;
  margin-left:auto;
  margin-right:auto;
  align-items: center;
  width: fit-content;
  max-width: 500px;
  border-radius: 7px;
  box-shadow: .1px .1px 3px rgb(162, 162, 162);

  .toaster-icon-container {
    text-align: center;
    top: 15px;
    right: 15px;
    position: absolute;

    .toaster-close-icon {
      cursor: pointer;
      height: 10px;
      width: 10px;
      min-width: 10px;
      max-width: 10px;
      margin: 6px;
      color: white;
    }
  }

  .toaster-message {
    color: white;
    text-align: center;
    padding: 18px 52px 18px 34px;
    :deep(a) {
      color: #7CD4FD;
      text-decoration: none;
      cursor: pointer;
    }
  }
}
</style>
